import React from 'react';
import PremiumSectionContainer from '../../ticketForm/components/PremiumSectionContainer';
import PremiumSection from '../../ticketForm/components/PremiumSection';
import { QuotePickupSection } from '../sections/QuotePickupSection';
import { QuoteDropoffSection } from '../sections/QuoteDropoffSection';
import { QuoteQuoteSection } from '../sections/QuoteQuoteSection';

export const QuoteFormBaseInputsBlock = (props) => {
  const { quoteFormBodyData } = props;
  return (
    <PremiumSectionContainer>
      <PremiumSection>
        <QuotePickupSection quoteFormBodyData={quoteFormBodyData} />
        <QuoteDropoffSection quoteFormBodyData={quoteFormBodyData} />
        <QuoteQuoteSection quoteFormBodyData={quoteFormBodyData} />
      </PremiumSection>
    </PremiumSectionContainer>
  );
};
